<template>
  <div class="dashboardGrid">
    <div class="fullWithCard">
      <div class="cardSubTitle">SOCIAL RELATIONSHIPS</div>
      <div id="simpleHighChartOptions"></div>
    </div>
    <div class="halfWithCard">
      <div class="cardSubTitle">Ämnen diskuterade på Facebook</div>
      <div class="tableWrapper">
        <table class="tableCard">
          <thead>
            <tr>
              <td>ÄMNE</td>
              <td>ANTAL</td>
              <td>FINNS PÅ HEMSIDA</td>
              <td>KONTEXT</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Barn</td>
              <td>21</td>
              <td><font-awesome-icon :icon="['fas', 'check']" class="iconCheckGreen" /></td>
              <td>
                <a href="#" @click="dialogTableVisible = true" alt="" class="channelColorFacebookText">Visa ämne i kontext</a>
                <el-dialog title="Barn used 21 times in..." width="1000px" :visible.sync="dialogTableVisible">
                  <el-table :data="gridData">
                    <el-table-column property="date" label="Date" width="150"></el-table-column>
                    <el-table-column property="user" label="User" width="150"></el-table-column>
                    <el-table-column property="sentence" label="Sentence" width="500"></el-table-column>
                    <el-table-column label="Post" width="100">
                      <el-button circle><font-awesome-icon :icon="['fas', 'external-link-alt']" /></el-button>
                    </el-table-column>
                  </el-table>
                </el-dialog>
              </td>
            </tr>
            <tr>
              <td>Sjuk</td>
              <td>32</td>
              <td><font-awesome-icon :icon="['fas', 'times']" class="iconTimesRed" /></td>
              <td>
                <a href="#" @click="dialogTableVisible = true" alt="" class="channelColorFacebookText">Visa ämne i kontext</a>
                <el-dialog title="Barn used 21 times in..." width="1000px" :visible.sync="dialogTableVisible">
                  <el-table :data="gridData">
                    <el-table-column property="date" label="Date" width="150"></el-table-column>
                    <el-table-column property="user" label="User" width="150"></el-table-column>
                    <el-table-column property="sentence" label="Sentence" width="500"></el-table-column>
                    <el-table-column label="Post" width="100">
                      <el-button circle><font-awesome-icon :icon="['fas', 'external-link-alt']" /></el-button>
                    </el-table-column>
                  </el-table>
                </el-dialog>
              </td>
            </tr>
            <tr>
              <td>Arbetssökande</td>
              <td>5</td>
              <td><font-awesome-icon :icon="['fas', 'times']" class="iconTimesRed" /></td>
              <td>
                <a href="#" @click="dialogTableVisible = true" alt="" class="channelColorFacebookText">Visa ämne i kontext</a>
                <el-dialog title="Barn used 21 times in..." width="1000px" :visible.sync="dialogTableVisible">
                  <el-table :data="gridData">
                    <el-table-column property="date" label="Date" width="150"></el-table-column>
                    <el-table-column property="user" label="User" width="150"></el-table-column>
                    <el-table-column property="sentence" label="Sentence" width="500"></el-table-column>
                    <el-table-column label="Post" width="100">
                      <el-button circle><font-awesome-icon :icon="['fas', 'external-link-alt']" /></el-button>
                    </el-table-column>
                  </el-table>
                </el-dialog>
              </td>
            </tr>
            <tr>
              <td>Handikappersättning</td>
              <td>35</td>
              <td><font-awesome-icon :icon="['fas', 'check']" class="iconCheckGreen" /></td>
              <td>
                <a href="#" @click="dialogTableVisible = true" alt="" class="channelColorFacebookText">Visa ämne i kontext</a>
                <el-dialog title="Barn used 21 times in..." width="1000px" :visible.sync="dialogTableVisible">
                  <el-table :data="gridData">
                    <el-table-column property="date" label="Date" width="150"></el-table-column>
                    <el-table-column property="user" label="User" width="150"></el-table-column>
                    <el-table-column property="sentence" label="Sentence" width="500"></el-table-column>
                    <el-table-column label="Post" width="100">
                      <el-button circle><font-awesome-icon :icon="['fas', 'external-link-alt']" /></el-button>
                    </el-table-column>
                  </el-table>
                </el-dialog>
              </td>
            </tr>
            <tr>
              <td>Andning</td>
              <td>9</td>
              <td><font-awesome-icon :icon="['fas', 'check']" class="iconCheckGreen" /></td>
              <td>
                <a href="#" @click="dialogTableVisible = true" alt="" class="channelColorFacebookText">Visa ämne i kontext</a>
                <el-dialog title="Barn used 21 times in..." width="1000px" :visible.sync="dialogTableVisible">
                  <el-table :data="gridData">
                    <el-table-column property="date" label="Date" width="150"></el-table-column>
                    <el-table-column property="user" label="User" width="150"></el-table-column>
                    <el-table-column property="sentence" label="Sentence" width="500"></el-table-column>
                    <el-table-column label="Post" width="100">
                      <el-button circle><font-awesome-icon :icon="['fas', 'external-link-alt']" /></el-button>
                    </el-table-column>
                  </el-table>
                </el-dialog>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="cardBottomContainer"><a href="#" alt="" class="cardBottomLink channelColorFacebookText">Visa Mer</a></div>
      </div>
    </div>
    <div class="halfWithCard">
      <div class="cardSubTitle">Top 5 inlägg</div>
        <div class="tableWrapper">
          <table class="tableCard">
            <thead>
              <tr>
                <td>POST</td>
                <td>LIKES</td>
                <td>COMMENTS</td>
                <td>SHARES</td>
                <td>SENTIMENT</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Du har säkert mängder...</td>
                <td>56</td>
                <td>12</td>
                <td>5</td>
                <td><el-tag type="success" size="small">60% Positive</el-tag></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>I morgon stänger vi kl. 12:00...</td>
                <td>49</td>
                <td>9</td>
                <td>4</td>
                <td><el-tag type="danger" size="small">51% Negative</el-tag></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Från och med oktober finns...</td>
                <td>30</td>
                <td>1</td>
                <td>0</td>
                <td><el-tag type="success" size="small">99% Positive</el-tag></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Varför får jag olika mycket...</td>
                <td>21</td>
                <td>1</td>
                <td>0</td>
                <td><el-tag type="danger" size="small">80% Negative</el-tag></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Idag har...</td>
                <td>1</td>
                <td>1</td>
                <td>0</td>
                <td><el-tag type="info" size="small">0%</el-tag></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
            </tbody>
          </table>
        <div class="cardBottomContainer"><a href="#" alt="" class="cardBottomLink channelColorFacebookText">Visa Mer</a></div>
      </div>
    </div>
    <div class="fullWithCard">
      <div class="cardSubTitle">POSTSVIEWS över TID</div>
      <div class="cardAlert">
        <el-alert
          title="Börja"
          type="info"
          description="För att få ut det mesta ifrån denna graf, klicka på en period i den andra grafen. Då förstorar du datan i första grafen...">
        </el-alert>
      </div>
      <div id="chart-line2"></div>
      <div id="chart-line"></div>
    </div>
    <div class="fullWithCard">
      <div class="cardSubTitle">POSTACTIONS över TID</div>
      <div id="chartLine"></div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'

const Highcharts = require('highcharts');
require('highcharts/modules/networkgraph')(Highcharts);

export default {
  data () {
    return {
      gridData: [{
        date: '2016-05-02',
        user: 'John Smith',
        sentence: 'No.1518,  Jinshajiang Road, Putuo District',
        postUrl: 'https://www.facebook.com/pg/foralder/posts/'
      }, {
        date: '2016-05-04',
        user: 'John Smith',
        sentence: 'No.1518,  Jinshajiang Road, Putuo District',
        postUrl: 'https://www.facebook.com/pg/foralder/posts/'
      }, {
        date: '2016-05-01',
        user: 'John Smith',
        sentence: 'No.1518,  Jinshajiang Road, Putuo District',
        postUrl: 'https://www.facebook.com/pg/foralder/posts/'
      }, {
        date: '2016-05-03',
        user: 'John Smith',
        sentence: 'No.1518,  Jinshajiang Road, Putuo District',
        postUrl: 'https://www.facebook.com/pg/foralder/posts/'
      }],
      dialogTableVisible: false
    };
  },

  components: {
    // ...
  },

  async mounted () {
    const optionsChartLine = {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      series: [{
        name: 'LIKES',
        data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
      },
      {
        name: 'COMMENTS',
        data: [100, 10, 41, 35, 51, 49, 62, 69, 91]
      },
      {
        name: 'SHARES',
        data: [49, 62, 69, 91, 55, 10, 41, 35, 51]
      }
      ],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2,
        lineCap: 'round' // round, butt , square
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        lines: {
          show: false
        },
        axisBorder: {
          show: false
        },
        borderColor: '#FFFFFF'
      },
      yaxis: {
        lines: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      scales: {
        xAxes: [{
          gridLines: {
              display: false
          }
        }]
      }
    }
    new ApexCharts(document.querySelector('#chartLine'), optionsChartLine).render();

    const data = this.generateDayWiseTimeSeries(new Date('11 Nov 2019').getTime(), 185, {
      min: 30,
      max: 90
    })
    const optionsline2 = {
      chart: {
        id: 'chart2',
        type: 'line',
        height: 230,
        toolbar: {
          autoSelected: 'pan',
          show: false
        }
      },
      colors: ['#546E7A'],
      stroke: {
        width: 3
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        opacity: 1
      },
      markers: {
        size: 0
      },
      series: [{
        data: data
      }],
      xaxis: {
        type: 'datetime'
      }
    }
    new ApexCharts(document.querySelector('#chart-line2'), optionsline2).render();

    const options = {
      chart: {
        id: 'chart1',
        height: 130,
        type: 'area',
        brush: {
          target: 'chart2',
          enabled: true
        },
        selection: {
          enabled: true,
          xaxis: {
            min: new Date('19 Jun 2017').getTime(),
            max: new Date('14 Aug 2017').getTime()
          }
        }
      },
      colors: ['#008FFB'],
      series: [{
        data: data
      }],
      fill: {
        type: 'gradient',
        gradient: {
          opacityFrom: 0.91,
          opacityTo: 0.1
        }
      },
      xaxis: {
        type: 'datetime',
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        tickAmount: 2
      }
    }
    new ApexCharts(document.querySelector('#chart-line'), options).render();

    /// RELATIONAL CHARTS:
    /// https://observablehq.com/@d3/force-directed-graph
    
    /// HIGHcharts relations
    Highcharts.setOptions({
      chart: {
        style: {
          fontFamily: 'Lato'
        }
      },
      plotOptions: {
        series: {
          dataLabels: {
            style: {
              color: '#008CBA',
              fontSize: '14px',
              fontWeight: 'normal',
              textOutline: 'null'
            }
          }
        }
      }
    });

    Highcharts.addEvent(
      Highcharts.Series,
      'afterSetOptions',
      function (e) {
        let colors = Highcharts.getOptions().colors
        let i = 0
        let nodes = {}
        // console.log(e.options.data)

        if (e.options.id !== 'relation-tree') {
          return;
        }

        e.options.data.forEach((link) => {
          // console.log(nodes[link[0]])
          if (link[2] === 'person') {
            nodes[link[0]] = { id: link[0], marker: { radius: 10, fillColor: '#ECDF8C' } }
            nodes[link[1]] = {
              id: link[1],
              marker: {
                  radius: 5
              },
              color: '#ADADAD'
            };
            // nodes['Jasmine'] = {
            //   id: 'Jasmine',
            //   marker: {
            //     radius: 28
            //   }
            // };
            // nodes[link[1]] = {
            //   id: link[1],
            //   marker: {
            //       radius: 18
            //   },
            //   color: colors[i++]
            // };
          } else {
            console.log('Else')
            // nodes[link[0]] = { id: link[0], marker: { radius: 15, fillColor: '#ADADAD' } }
            // nodes[link[1]] = {
            //   id: link[1],
            //   color: nodes[link[0]].color
            // };
          }
        });

        e.options.nodes = Object.keys(nodes).map((id) => {
          return nodes[id];
        });
      }
    );

    const simpleHighChartOptions = {
      // Images: https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/maps/demo/pattern-fill-map
      // https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/series-networkgraph/forces
      // https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/series-networkgraph/integration-comparison
      chart: {
        type: 'networkgraph'
      },
      title: {
          text: ''
      },
      plotOptions: {
        networkgraph: {
          layoutAlgorithm: {
              enableSimulation: true,
              friction: -0.9
              // integration: 'euler'
              // linkLength: 25
          },
          keys: ['from', 'to']
          // marker: {
          //     radius: 50,
          //     lineWidth: 1
          // },
          // link: {
          //   color: 'blue'
          // }
        }
      },
      series: [
        {
          id: 'relation-tree',
          // marker: {
          //   radius: 13
          // },
          dataLabels: {
            enabled: true,
            textPath: {
              enabled: false
            },
            linkFormat: '',
            allowOverlap: true
          },
          draggable: {
            enabled: true
          },
          data: [
            ['Jasmine', 'SCA', 'person'],
            ['Jasmine', 'Skanska', 'person'],
            ['Sofia', 'SCA', 'person'],
            ['Sofia', 'Arbetslös', 'person'],
            ['Rickard', 'Entrepenör', 'person'],
            ['Hans', 'Skanska', 'person'],
            ['Cissi', 'ICA', 'person'],
            ['Petter', 'Entrepenör', 'person'],
            ['Alice', 'Servanet', 'person'],
            ['Amanda', 'SCA', 'person'],
            ['Olu', 'Bilbolaget', 'person'],
            ['Kenneth', 'Entrepenör', 'person'],
            ['Andreas', 'Hedbergska', 'person'],
            ['Eliza', 'Securitas', 'person'],
            ['Sofia', 'Samhall', 'person'],
            ['Ola', 'Skanska', 'person'],
            ['Janna', 'SCA', 'person'],
            ['Janna', 'Hedbergska', 'person'],
            ['Jordi', 'Securitas', 'person'],
            ['Rickard', 'Samhall', 'person'],
            ['Roland', 'Servanet', 'person'],
            ['Jordan', 'Entrepenör', 'person'],
            ['Sanna', 'Servanet', 'person'],
            ['Alice', 'Volvo', 'person'],
            ['Sofia', 'Securitas', 'person'],
            ['Jacob', 'SCA', 'person'],
            ['Ann', 'Bilbolaget', 'person'],
            ['Jessica', 'SCA', 'person'],
            ['Hans', 'Skanska', 'person'],
            ['Irene', 'Bilbolaget', 'person'],
            ['Fredrik', 'ICA', 'person'],
            ['Annie', 'Skanska', 'person'],
            ['Ramin', 'Hedbergska', 'person'],
            ['Eliza', 'Bilbolaget', 'person'],
            ['Sanna', 'Hedbergska', 'person'],
            ['Jim', 'H&M', 'person'],
            ['Mustafa', 'Volvo', 'person'],
            ['Ann', 'Skanska', 'person'],
            ['Peter', 'Servanet', 'person'],
            ['Sofia', 'Volvo', 'person'],
            ['Hanna', 'SCA', 'person'],
            ['Jasmine', 'Mittuniversitetet', 'person'],
            ['Ann', 'Samhall', 'person'],
            ['Ismail', 'Sogeti', 'person'],
            ['Reza', 'Volvo', 'person'],
            ['Annie', 'Hedbergska', 'person'],
            ['Patricia', 'CSN', 'person'],
            ['Ismail', 'Arbetslös', 'person'],
            ['Irene', 'Entrepenör', 'person'],
            ['Yvonne', 'Volvo', 'person'],
            ['Mustafa', 'Arbetslös', 'person'],
            ['Petra', 'CSN', 'person'],
            ['Johana', 'Samhall', 'person'],
            ['Emma', 'ICA', 'person'],
            ['Olu', 'Bilbolaget', 'person'],
            ['Thomas', 'Sogeti', 'person'],
            ['Thomas', 'H&M', 'person'],
            ['Jim', 'Bilbolaget', 'person'],
            ['Sanna', 'Entrepenör', 'person'],
            ['Marika', 'Servanet', 'person'],
            ['Ann-Charlotte', 'Mittuniversitetet', 'person'],
            ['Eliza', 'Mittuniversitetet', 'person'],
            ['Bengt', 'Hedbergska', 'person'],
            ['Hanna', 'Volvo', 'person'],
            ['Sadie', 'Bilbolaget', 'person'],
            ['Ida', 'Skanska', 'person'],
            ['Jessica', 'CSN', 'person'],
            ['Ida', 'Securitas', 'person'],
            ['Ramin', 'Securitas', 'person'],
            ['Rickard', 'SCA', 'person'],
            ['Olu', 'Hedbergska', 'person'],
            ['Roland', 'Sogeti', 'person'],
            ['Ismail', 'Arbetslös', 'person'],
            ['Annie', 'Bilbolaget', 'person'],
            ['Reza', 'ICA', 'person'],
            ['Ann', 'Volvo', 'person'],
            ['Ramin', 'Hedbergska', 'person'],
            ['Jennifer', 'Entrepenör', 'person'],
            ['Sadie', 'Bilbolaget', 'person'],
            ['Ramin', 'H&M', 'person'],
            ['Carola', 'CSN', 'person'],
            ['Jessica', 'SCA', 'person'],
            ['Ida', 'SCA', 'person'],
            ['Petter', 'Skanska', 'person'],
            ['Reza', 'SCA', 'person'],
            ['Sofia', 'Bilbolaget', 'person'],
            ['Kenneth', 'Securitas', 'person'],
            ['Jordi', 'Mittuniversitetet', 'person'],
            ['Johana', 'CSN', 'person'],
            ['Hanna', 'Sogeti', 'person'],
            ['Roland', 'CSN', 'person'],
            ['Marika', 'SCA', 'person'],
            ['Sofia', 'Servanet', 'person'],
            ['Peter', 'Arbetslös', 'person'],
            ['Hanna', 'Servanet', 'person'],
            ['Hans', 'Bilbolaget', 'person'],
            ['Ann', 'Arbetslös', 'person'],
            ['Bengt', 'ICA', 'person'],
            ['Hanna', 'Volvo', 'person'],
            ['Bengt', 'H&M', 'person']
          ]
        }
      ]
    };
    Highcharts.chart('simpleHighChartOptions', simpleHighChartOptions);

    /// HighCharts
    // Highcharts.addEvent(
    //     Highcharts.Series,
    //     'afterSetOptions',
    //     function (e) {
    //         let colors = Highcharts.getOptions().colors
    //         let i = 0
    //         let nodes = {};

    //         if (
    //             this instanceof Highcharts.seriesTypes.networkgraph &&
    //             e.options.id === 'lang-tree'
    //         ) {
    //           e.options.data.forEach(function (link) {
    //             if (link[0] === 'Proto Indo-European') {
    //                 nodes['Proto Indo-European'] = {
    //                   id: 'Proto Indo-European',
    //                   marker: {
    //                     radius: 20
    //                   }
    //                 };
    //                 nodes[link[1]] = {
    //                   id: link[1],
    //                   marker: {
    //                       radius: 10
    //                   },
    //                   color: colors[i++]
    //                 };
    //             } else if (nodes[link[0]] && nodes[link[0]].color) {
    //                 nodes[link[1]] = {
    //                   id: link[1],
    //                   color: nodes[link[0]].color
    //                 };
    //             }
    //           });

    //           e.options.nodes = Object.keys(nodes).map((id) => {
    //               return nodes[id];
    //           });
    //         }
    //     }
    // );
    // const highchartsOptions = {
    //   chart: {
    //     type: 'networkgraph',
    //     height: '100%'
    //   },
    //   title: {
    //       text: ''
    //   },
    //   plotOptions: {
    //     networkgraph: {
    //       keys: ['from', 'to'],
    //       layoutAlgorithm: {
    //         enableSimulation: true,
    //         friction: -0.9
    //       }
    //     }
    //   },
    //   series: [
    //     {
    //       dataLabels: {
    //         enabled: true,
    //         linkFormat: ''
    //       },
    //       id: 'lang-tree',
    //       date: [
    //         ['Proto Indo-European', 'Balto-Slavic'],
    //         ['Proto Indo-European', 'Germanic'],
    //         ['Proto Indo-European', 'Celtic'],
    //         ['Proto Indo-European', 'Italic'],
    //         ['Proto Indo-European', 'Hellenic'],
    //         ['Proto Indo-European', 'Anatolian'],
    //         ['Proto Indo-European', 'Indo-Iranian'],
    //         ['Proto Indo-European', 'Tocharian'],
    //         ['Indo-Iranian', 'Dardic'],
    //         ['Indo-Iranian', 'Indic'],
    //         ['Indo-Iranian', 'Iranian'],
    //         ['Iranian', 'Old Persian'],
    //         ['Old Persian', 'Middle Persian'],
    //         ['Indic', 'Sanskrit'],
    //         ['Italic', 'Osco-Umbrian'],
    //         ['Italic', 'Latino-Faliscan'],
    //         ['Latino-Faliscan', 'Latin'],
    //         ['Celtic', 'Brythonic'],
    //         ['Celtic', 'Goidelic'],
    //         ['Germanic', 'North Germanic'],
    //         ['Germanic', 'West Germanic'],
    //         ['Germanic', 'East Germanic'],
    //         ['North Germanic', 'Old Norse'],
    //         ['North Germanic', 'Old Swedish'],
    //         ['North Germanic', 'Old Danish'],
    //         ['West Germanic', 'Old English'],
    //         ['West Germanic', 'Old Frisian'],
    //         ['West Germanic', 'Old Dutch'],
    //         ['West Germanic', 'Old Low German'],
    //         ['West Germanic', 'Old High German'],
    //         ['Old Norse', 'Old Icelandic'],
    //         ['Old Norse', 'Old Norwegian'],
    //         ['Old Norwegian', 'Middle Norwegian'],
    //         ['Old Swedish', 'Middle Swedish'],
    //         ['Old Danish', 'Middle Danish'],
    //         ['Old English', 'Middle English'],
    //         ['Old Dutch', 'Middle Dutch'],
    //         ['Old Low German', 'Middle Low German'],
    //         ['Old High German', 'Middle High German'],
    //         ['Balto-Slavic', 'Baltic'],
    //         ['Balto-Slavic', 'Slavic'],
    //         ['Slavic', 'East Slavic'],
    //         ['Slavic', 'West Slavic'],
    //         ['Slavic', 'South Slavic'],
    //         // Leaves:
    //         ['Proto Indo-European', 'Phrygian'],
    //         ['Proto Indo-European', 'Armenian'],
    //         ['Proto Indo-European', 'Albanian'],
    //         ['Proto Indo-European', 'Thracian'],
    //         ['Tocharian', 'Tocharian A'],
    //         ['Tocharian', 'Tocharian B'],
    //         ['Anatolian', 'Hittite'],
    //         ['Anatolian', 'Palaic'],
    //         ['Anatolian', 'Luwic'],
    //         ['Anatolian', 'Lydian'],
    //         ['Iranian', 'Balochi'],
    //         ['Iranian', 'Kurdish'],
    //         ['Iranian', 'Pashto'],
    //         ['Iranian', 'Sogdian'],
    //         ['Old Persian', 'Pahlavi'],
    //         ['Middle Persian', 'Persian'],
    //         ['Hellenic', 'Greek'],
    //         ['Dardic', 'Dard'],
    //         ['Sanskrit', 'Sindhi'],
    //         ['Sanskrit', 'Romani'],
    //         ['Sanskrit', 'Urdu'],
    //         ['Sanskrit', 'Hindi'],
    //         ['Sanskrit', 'Bihari'],
    //         ['Sanskrit', 'Assamese'],
    //         ['Sanskrit', 'Bengali'],
    //         ['Sanskrit', 'Marathi'],
    //         ['Sanskrit', 'Gujarati'],
    //         ['Sanskrit', 'Punjabi'],
    //         ['Sanskrit', 'Sinhalese'],
    //         ['Osco-Umbrian', 'Umbrian'],
    //         ['Osco-Umbrian', 'Oscan'],
    //         ['Latino-Faliscan', 'Faliscan'],
    //         ['Latin', 'Portugese'],
    //         ['Latin', 'Spanish'],
    //         ['Latin', 'French'],
    //         ['Latin', 'Romanian'],
    //         ['Latin', 'Italian'],
    //         ['Latin', 'Catalan'],
    //         ['Latin', 'Franco-Provençal'],
    //         ['Latin', 'Rhaeto-Romance'],
    //         ['Brythonic', 'Welsh'],
    //         ['Brythonic', 'Breton'],
    //         ['Brythonic', 'Cornish'],
    //         ['Brythonic', 'Cuymbric'],
    //         ['Goidelic', 'Modern Irish'],
    //         ['Goidelic', 'Scottish Gaelic'],
    //         ['Goidelic', 'Manx'],
    //         ['East Germanic', 'Gothic'],
    //         ['Middle Low German', 'Low German'],
    //         ['Middle High German', '(High) German'],
    //         ['Middle High German', 'Yiddish'],
    //         ['Middle English', 'English'],
    //         ['Middle Dutch', 'Hollandic'],
    //         ['Middle Dutch', 'Flemish'],
    //         ['Middle Dutch', 'Dutch'],
    //         ['Middle Dutch', 'Limburgish'],
    //         ['Middle Dutch', 'Brabantian'],
    //         ['Middle Dutch', 'Rhinelandic'],
    //         ['Old Frisian', 'Frisian'],
    //         ['Middle Danish', 'Danish'],
    //         ['Middle Swedish', 'Swedish'],
    //         ['Middle Norwegian', 'Norwegian'],
    //         ['Old Norse', 'Faroese'],
    //         ['Old Icelandic', 'Icelandic'],
    //         ['Baltic', 'Old Prussian'],
    //         ['Baltic', 'Lithuanian'],
    //         ['Baltic', 'Latvian'],
    //         ['West Slavic', 'Polish'],
    //         ['West Slavic', 'Slovak'],
    //         ['West Slavic', 'Czech'],
    //         ['West Slavic', 'Wendish'],
    //         ['East Slavic', 'Bulgarian'],
    //         ['East Slavic', 'Old Church Slavonic'],
    //         ['East Slavic', 'Macedonian'],
    //         ['East Slavic', 'Serbo-Croatian'],
    //         ['East Slavic', 'Slovene'],
    //         ['South Slavic', 'Russian'],
    //         ['South Slavic', 'Ukrainian'],
    //         ['South Slavic', 'Belarusian'],
    //         ['South Slavic', 'Rusyn']
    //       ]
    //     }
    //   ]
    // };
    // Highcharts.chart('container', highchartsOptions);
  },

  methods: {
    /*
      // this function will generate output in this format
      // data = [
          [timestamp, 23],
          [timestamp, 33],
          [timestamp, 12]
          ...
      ]
    */
    generateDayWiseTimeSeries: function (baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = baseval;
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

        series.push([x, y]);
        baseval += 86400000;
        i++;
      }
      return series;
    }
  }

};
</script>
